import { Navigate, useParams } from 'react-router-dom'

/**
 * Redirects from /admin/reported-reviews/:reviewId to /admin/reviews?reviewId=:reviewId
 */
const ReportedReviewRedirect = (): JSX.Element => {
  const { reviewId } = useParams<{ reviewId: string }>()
  return <Navigate to={`/admin/reviews?reviewId=${reviewId}`} replace />
}

export default ReportedReviewRedirect
